import { IBufferMetrics } from '@bufferController/BufferMetrics/IBufferMetrics';
import { EDebuggableModuleState, IDebbugable, TDebuggableAdditionalInfo } from '@customTypes/common';

export class CommonPlayerDebugInfo implements IDebbugable {
  public state: EDebuggableModuleState = EDebuggableModuleState.OK;
  public status: string = 'Idle';
  public groups: string[] = ['general'];

  private _lastMetrics: IBufferMetrics | null = null;

  public get additionalInfo(): TDebuggableAdditionalInfo {
    return {
      totalHeapSize: performance.memory?.totalJSHeapSize,
      usedHeapSize: performance.memory?.usedJSHeapSize,
      sizeLimit: performance.memory?.jsHeapSizeLimit,
      ...(this._lastMetrics || {}),
    };
  }
}
